import React from 'react';

import artwork from '../../../../Assets/Linkages/SpaceOutreachFilm/Research-Meets-Reel-Artwork.png';

const ResearchMeetsReel = () => (
  <section className="outreach-film-feature" aria-labelledby="research-meets-reel-title">
    <div className="outreach-film-feature-inner">
      <figure className="outreach-film-feature-artwork">
        <img src={artwork} alt="Research Meets Reel artwork for Jahan Aur Bhi Hain" loading="lazy" />
      </figure>

      <div className="outreach-film-feature-copy">
        <p className="section-eyebrow">WHERE SCIENCE BECOMES STORY</p>
        <h2 id="research-meets-reel-title">Research Meets Reel</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          Jahan Aur Bhi Hain — Beyond the Blue fuses scientific vision with cinematic storytelling.
          Developed by faculty, researchers, and filmmakers, it draws on surveys, workshops, and
          script sessions to create a narrative that blends academic rigor with emotional depth.
          Focused on space awareness, the telefilm addresses climate, environmental challenges, and
          disaster preparedness, serving as a powerful platform for space science communication and outreach.
        </p>
        <a
          className="outreach-film-trailer-link"
          href="https://www.youtube.com/watch?v=FWvh6ZHEAlM"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Watch the Jahan Aur Bhi Hain teaser on YouTube"
        >
          Watch Teaser <span aria-hidden="true">→</span>
        </a>
      </div>
    </div>
  </section>
);

export default ResearchMeetsReel;
